import { FC, useCallback } from 'react';
import { Stack, Text, Image, Button, Icon } from '@chakra-ui/react';
import Logo from '@resources/images/logo-gattinoni.png';
import { MdArrowBack, MdLogout } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useMsal, useAccount } from '@azure/msal-react';

interface Props {
    title: string;
    backgroundImg: string;
    backgroundPosition?: 'center' | 'top' | 'bottom';
    goBack?: boolean;
    subtitle?: string;
    showUser?: boolean;
}

const HeaderComponent: FC<Props> = ({
    title,
    backgroundImg,
    backgroundPosition = 'center',
    goBack = false,
    subtitle = '',
    showUser = true,
}) => {
    const navigate = useNavigate();
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const handleGoBack = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    const handleLogout = useCallback(() => {
        instance.logoutRedirect();
    }, [instance]);

    return (
        <Stack
            backgroundImage={backgroundImg}
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
            backgroundPosition={`${backgroundPosition} center`}
        >
            <Stack justify="center" align="center" spacing="0px" alignSelf="stretch" background="rgba(0, 0, 0, 0.4)">
                <Stack
                    paddingX="50px"
                    paddingY="30px"
                    alignSelf="stretch"
                    direction="row"
                    justify="space-between"
                    align="center"
                    spacing="20px"
                >
                    <Image width="192.31px" height="50px" src={Logo} />
                    {showUser && account ? (
                        <Stack direction="row" align="center" spacing="15px">
                            <Text color="white">{account.username}</Text>
                            <Button
                                variant="link"
                                color="white"
                                leftIcon={<Icon as={MdLogout} />}
                                onClick={handleLogout}
                            >
                                Esci
                            </Button>
                        </Stack>
                    ) : null}
                </Stack>
                <Stack
                    paddingX="50px"
                    paddingBottom="50px"
                    justify="center"
                    align="center"
                    spacing="25px"
                    alignSelf="stretch"
                >
                    <Text variant="titleXL" color="white" alignSelf="stretch" textAlign="center">
                        {title}
                    </Text>
                    {subtitle ? (
                        <Text variant="subtitle" color="white" width="860px" maxWidth="100%" textAlign="center">
                            {subtitle}
                        </Text>
                    ) : null}
                    {goBack ? (
                        <Button variant="link" leftIcon={<Icon as={MdArrowBack} />} onClick={handleGoBack}>
                            Indietro
                        </Button>
                    ) : null}
                </Stack>
            </Stack>
        </Stack>
    );
};

export default HeaderComponent;
